"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.WHITE = exports.WEATHER_ICON_SELECTED_COLOR = exports.WEATHER_ICON_COLOR = exports.START_GRADIENT = exports.IMPORTANT_COLOR_OPAQUE = exports.IMPORTANT_COLOR = exports.GRAYED_OUT_COLOR = exports.END_GRADIENT = exports.CUSTOMER_CONSUMPTION = exports.BRAND_GREEN = exports.BEFORE_PTO_COLOR = exports.BATTERY_OPAQUE = exports.BATTERY_CHARGE = exports.BATTERY = void 0;
var IMPORTANT_COLOR = '#FFD45C';
exports.IMPORTANT_COLOR = IMPORTANT_COLOR;
var IMPORTANT_COLOR_OPAQUE = 'rgba(255, 229, 163)';
exports.IMPORTANT_COLOR_OPAQUE = IMPORTANT_COLOR_OPAQUE;
var BEFORE_PTO_COLOR = 'rgb(198, 198, 198, .5)';
exports.BEFORE_PTO_COLOR = BEFORE_PTO_COLOR;
var WEATHER_ICON_COLOR = '#B2ADA6';
exports.WEATHER_ICON_COLOR = WEATHER_ICON_COLOR;
var WEATHER_ICON_SELECTED_COLOR = '#333333';
exports.WEATHER_ICON_SELECTED_COLOR = WEATHER_ICON_SELECTED_COLOR;
var BATTERY = '#32CAA2';
exports.BATTERY = BATTERY;
var BATTERY_OPAQUE = 'rgba(0, 176, 133, .5)';
exports.BATTERY_OPAQUE = BATTERY_OPAQUE;
var GRAYED_OUT_COLOR = '#DEDBD6';
exports.GRAYED_OUT_COLOR = GRAYED_OUT_COLOR;
var BRAND_GREEN = '#32CAA2';
exports.BRAND_GREEN = BRAND_GREEN;
var WHITE = '#FFFFFF';
exports.WHITE = WHITE;
var START_GRADIENT = '#596E9A';
exports.START_GRADIENT = START_GRADIENT;
var END_GRADIENT = '#7E8EAE';
exports.END_GRADIENT = END_GRADIENT;
var CUSTOMER_CONSUMPTION = '#F48503';
exports.CUSTOMER_CONSUMPTION = CUSTOMER_CONSUMPTION;
var BATTERY_CHARGE = '#00B085';
exports.BATTERY_CHARGE = BATTERY_CHARGE;